import { createContext, forwardRef } from "react";

export const LabelContext = createContext({});

export const withLabelContext = Component =>
  forwardRef((props, ref) => (
    <LabelContext.Consumer>
      {labels => <Component {...props} labels={labels} ref={ref} />}
    </LabelContext.Consumer>
  ));
